import * as actionTypes from '../actions/record/constants';

const initialState = {
  loading: false, // loader
  data: {},
  error: false,
  currentRecord: null,
  currentTab: 'pricing_title',
};
const recordReducer = (state = initialState, action) => {
  const data = state.data ? state.data : {};
  const { id, payload } = action;
  switch (action.type) {
    case actionTypes.FETCH_RECORD_REQUEST:
    case actionTypes.FETCH_OFFER_REQUEST:
    case actionTypes.POST_OFFER_REQUEST:
    case actionTypes.POST_PARTNER_REQUEST:
    case actionTypes.UPDATE_OFFER_REQUEST:
    case actionTypes.POST_PRICING_REQUEST:
    case actionTypes.POST_COVERAGEFORD_REQUEST:
    case actionTypes.POST_PURCHASE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case actionTypes.FETCH_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          [id]: { ...payload },
        },
        error: false,
      };

    case actionTypes.UPDATE_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          [id]: {
            ...state.data[id],
            ...payload,
          },
        },
        error: false,
      };

    case actionTypes.OPEN_RECORD: {
      const { recordId } = payload;
      return {
        ...state,
        currentRecord: recordId,
      };
    }

    case actionTypes.PUT_INIT_RECORD:
      return {
        ...state,
        loading: false,
        data: {
          0: payload,
        },
        error: false,
        currentRecord: 0,
      };

    case actionTypes.CLEAN_STORE:
      return {
        currentRecord: null,
        loading: false,
        data: {},
        error: false,
      };

    case actionTypes.FETCH_OFFER_SUCCESS:
      data[id].offers = payload;
      return {
        ...state,
        loading: false,
        data: { ...data },
        error: false,
      };

    case actionTypes.POST_OFFER_SUCCESS:
    case actionTypes.UPDATE_OFFER_SUCCESS:
    case actionTypes.POST_COVERAGEFORD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...data },
        error: false,
      };

    case actionTypes.FETCH_RECORD_FAILURE:
    case actionTypes.FETCH_OFFER_FAILURE:
    case actionTypes.UPDATE_OFFER_FAILURE:
    case actionTypes.POST_OFFER_FAILURE:
    case actionTypes.POST_PRICING_FAILURE:
    case actionTypes.FETCH_PRICINGHISTORY_FAILURE:
    case actionTypes.POST_PURCHASE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case actionTypes.FETCH_PRICING: {
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            quotation: payload,
          },
        },
        error: false,
      };
    }

    case actionTypes.FETCH_VEHICLE_VERSIONS: {
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            versions: payload,
          },
        },
      };
    }

    case actionTypes.SAVE_USER_PRICING: {
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            userPricing: payload,
          },
        },
      };
    }

    case actionTypes.FETCH_PREFERENCES_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            preferences: payload,
          },
        },
      };

    case actionTypes.FETCH_QUOTATION_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            quotation: {
              ...state.data[id].quotation,
              ...payload,
            },
          },
        },
      };

    case actionTypes.CURRENT_TAB: {
      return {
        ...state,
        currentTab: payload,
      };
    }

    case actionTypes.RESET_STATE:
      return initialState;

    case actionTypes.FETCH_PRICINGHISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            history: payload,
          },
        },
      };
    }

    case actionTypes.SET_OFFERS_SALES: {
      const tt = {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            trade: {
              ...state.data[id].trade,
              offers: payload.offers,
            },
          },
        },
      };
      return tt;
    }

    case actionTypes.GET_TRADE: {
      const test = {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            trade: { ...state.data[id].trade, ...payload.tradeRedux },
          },
        },
      };
      return test;
    }

    case actionTypes.REINITIALISE_OFFERAT_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            trade: {
              offers: payload,
            },
          },
        },
        loading: false,
        error: false,
      };
    }

    case actionTypes.SET_ENTRY_STOCK_OPTION: {
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            entryStockOption: payload,
          },
        },
      };
    }

    case actionTypes.SET_RECORD_CONFIG_FORM: {
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            record: {
              ...state.data[id].record,
              configType: payload,
            },
          },
        },
      };
    }

    case actionTypes.FETCH_SOURCE_INFO: {
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            sourceInfos: payload,
          },
        },
      };
    }

    case actionTypes.FETCH_Buyers_INFO: {
      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...state.data[id],
            buyers: payload,
          },
        },
      };
    }

    case actionTypes.POST_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
};

export default recordReducer;
